module.exports = __webpack_public_path__ + "static/media/bluelabel.ae621238.png";